export default {
	notificationSending: 'Nastavení odesílání notifikací',
	informationCreation: 'Nastavení vzniku informací',
	mainHeader: 'Nastavení',

	// notifications sending headers
	summaryNotification: 'Odeslání souhrnné notifikace',
	tasksAndInformationByEmail: 'Odeslání úkolů a informací e-mailem',
	tasksAndInformationForSanMarco: 'Odeslání úkolů a informací do San Marco',
	eObchodnikNotifications: 'Odeslání notifikací do eObchodníka',
	notificationsBySMS: 'Odeslání notifikací formou SMS',
	taskCreationFailByEmail: 'Odeslání e-mailu o nezaložených úkolech',
	alwaysTurnedOnNotifications: 'Notifikace, které nelze uživatelsky vypnout',
	smsNotifications: 'Odeslání notifikací formou sms',
	lossClientSMETasksReport: 'Odeslání reportu o úkolech Škodový klient SME',

	// information creation headers
	tasksSettings: 'Nastavení úkolu',
	leadsSettings: 'Nastavení příležitostí',
	informationSettings: 'Nastavení informací',

	customSettingsModalTitle: 'Vlastní nastavení',

	// notification sending tooltips
	summaryNotificationHeaderTooltip:
		'Nastavení pro zasílání souhrnných notifikací na e-mail, které odchází jednou denně a informují o vzniku jednotlivých položek.',
	tasksAndInformationByEmailHeaderTooltip:
		'Nastavení zajistí, že jsou úkoly a informace zasílány do e-mailu obchodníka.',
	tasksAndInformationForSanMarcoHeaderTooltip: 'Nastavení zobrazení úkolů a informací v San Marco.',
	eObchodnikNotificationsHeaderTooltip: 'Nastavení zasílání notifikací do aplikace eObchodník Plus.',
	taskCreationFailByEmailHeaderTooltip: 'Nastavení zasílání e-mailové notifikace o nezaložených úkolech.',
	alwaysTurnedOnNotificationsHeaderTooltip:
		'Seznam notifikací, které můžete do emailu dostat a jejichž vznik si nemůžete uživatelsky nastavit.',
	smsNotificationsHeaderTooltip: 'Nastavení zasílání SMS notifikace o vzniku Neinkasní intervence ŽP.',
	lossClientSMETasksReportTooltip:
		'Nastavení zasílání e-mailové notifikace s reportem o splněných a nesplněných úkolech Škodový klient SME',

	// information creation tooltips
	tasksSettingsTooltip:
		'Zde máte zobrazené typy úkolů, které vznikají do Kanceláře. Plnění úkolů je povinné a jejich vznik si nelze vypnout.',
	leadsSettingsTooltip:
		'Zde máte zobrazené typy příležitostí, které vznikají do Kanceláře. Vznik příležitostí si nelze vypnout.',
	informationSettingsTooltip:
		'Zde si můžete nastavit vznik Informací. Pokud nechcete dostávat některou z níže uvedených Informací, tak ji odškrtněte. V takovém případě vám daná Informace k jednotlivým smlouvám nebude vůbec vznikat do Kanceláře.',

	customSettings: 'Vlastní nastavení',
	saveEmail: 'Uložit e-mail',
	tasks: 'Úkoly',
	leads: 'Příležitosti',
	information: 'Informace',
	selectAll: 'Označit vše',
	unselectAll: 'Odznačit vše',

	marketPlaceAgencies: {
		header: 'Nastavení oblastí pro příležitosti',
		notPlacedManagers: 'Nezařazení manažeři',
		region: 'Region',
		segment: 'Segment',
		revertChanges: 'Vrátit změny',
		assignedZipCodes: 'Přiřazené PSČ',
		managersInAgency: 'Manažeři v oblasti',
		emptyNotPlacedManagers: 'Všichni manažeři a obchodníci jsou zařazeni v nějaké oblasti.',
		noManagersAvailable: 'Na oblasti nejsou žádní manažeři ani obchodníci.',
		someAgenciesAreWithoutManagers: 'Některé oblasti nemají přiřazené žádné obchodníky.',
		confirmSave: 'Opravdu si přejete uložit změny?',
		confirmRevert: 'Opravdu chcete vrátit všechny provedené změny?',
		confirmChangeFilterOption: 'Provedené změny nebyly uloženy.',
		managerIncludedInAgency: 'Manažer je zařazený v oblasti spolu se svými podřízenými.',
		managerNotIncludedInAgency: 'V oblasti jsou zařazeni jen podřízení bez manažera.',
	},

	editAgencyModal: {
		assigned: 'Zařazení',
		unassigned: 'Nezařazení',
		withSubordinates: 'Včetně podřízených',
		nonUniqueOrNonExistantUser:
			'Uživatel neexistuje nebo nemůže být do oblasti zařazen kvůli chybnému regionu, roli nebo distribučnímu kanálu.',
	},
};
